<template>
  <RevButtonBase
    class="rounded-sm body-1-bold box-border flex gap-4 text-nowrap border px-12 py-8 hover:bg-action-default-min-hover motion-safe:transition-colors motion-safe:duration-200 motion-safe:ease-in"
    target="_blank"
    :to="`https://repair.evy.eu/${locale}/backmarket?utm_source=header&utm_medium=website`"
    :tracking
  >
    <IconRepairStore />
    <span>
      {{ i18n(translations.repair) }}
    </span>
  </RevButtonBase>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconRepairStore } from '@ds/icons/IconRepairStore'

import translations from './RepairButton.translations'

const locale = useI18nLocale()
const i18n = useI18n()

const route = useRoute()

const tracking = computed((): Record<string, string> => {
  const value = route.name?.toString()

  return value
    ? { name: 'repair', zone: 'header', value }
    : { name: 'repair', zone: 'header' }
})
</script>
